/* eslint-disable max-len */

import { API } from '../../';

export default {
	accounts: {
		newPassword: {
			lhs: {
				content: 'Learn how to quickly produce highly interactive eLearning material.',
				heading: 'Get the full experience',
			},
			rhs: {
				backHref: '/',
				backLabel: 'Go back',
				buttonLabel: 'Create new password',
				heading: 'New password',
			},
			successDialog: {
				content: 'Your password has been reset. Click below to sign-in.',
				heading: 'We’ve set your new password',
				href: '/sign-in',
				linkLabel: 'Sign in',
			},
		},
		register: {
			lhs: {
				content: 'Learn how to quickly produce highly interactive eLearning material.',
				heading: 'Get the full experience',
			},
			rhs: {
				backHref: '/',
				backLabel: 'Go back',
				bottomContent: 'Already have an account? [Sign in](sign-in).',
				buttonLabel: 'Activate trial',
				heading: 'Start a free TAGGIS trial',
				topContent: 'By signing up, you are agreeing to our [terms](/register/terms) and our [privacy policy](/register/privacy), including our [cookie policy](/register/cookies).',
			},
		},
		resetPassword: {
			lhs: {
				content: 'Learn how to quickly produce highly interactive eLearning material.',
				heading: 'Get the full experience',
			},
			rhs: {
				backHref: '/sign-in',
				backLabel: 'Sign in',
				buttonLabel: 'Send',
				headerContent: 'Don’t have an account? [Get started](register).',
				heading: 'Reset password',
			},
			successDialog: {
				content: 'Please check your email inbox for next steps.',
				heading: 'We’ve sent you an email',
				href: '/sign-in',
				linkLabel: 'Sign in',
			},
		},
		signIn: {
			lhs: {
				content: 'Learn how to quickly produce highly interactive eLearning material.',
				heading: 'Get the full experience',
			},
			rhs: {
				backHref: '/',
				backLabel: 'Go back',
				bottomContent: 'Forgot your password? Don’t worry, just click [here](reset-password) to get it fixed.',
				buttonLabel: 'Sign in',
				headerContent: 'Don’t have an account? [Get started](register).',
				heading: 'Sign in',
				loginMessage: 'Log in to your account',
			},
		},
	},

	common: {
		backLabel: 'Go back',
		confirmPasswordLabel: 'Confirm password',
		confirmPasswordValidationMessage: 'Please ensure that your passwords match.',
		emailLabel: 'Email',
		firstNameLabel: 'First name',
		lastNameLabel: 'Last name',
		messageLabel: 'Message',
		organizationLabel: 'Organization',
		organizationRoleLabel: 'Role',
		passwordLabel: 'Password',
		passwordValidationMessage: 'Please provide a password that is six (6) characters long, with at least one uppercase letter, one lowercase letter, and one number.',
		serverErrorContent: 'Sorry, but we’ve encountered an error while processing this form. Please try again later.',
		serverErrorMessage: 'Something went wrong...',
		validationMessage: 'Please correct the following issues:',
	},
	faq: {
		contactFormContent: 'We’re ready to lead you into the future. Create virtual environments with us',
		contactFormHeading: 'Still have questions?',
		heading: {
			subTitle: 'FAQ',
			title: 'Frequently asked questions:',
		},
		questions: [
			{
				answer: {
					text: 'The free trial version lasts for 60 days. It includes the core feature set, so you can experience the start of your own course creation.',
				},
				question: 'How long does the trial last?',
			},
			{
				answer: {
					text: 'We offer several options for our customers: Bronze, Silver, Gold and Enterprise packages. Learn more about [Pricing](/pricing)',
				},
				question: 'What service packages are available?',
			},
			{
				answer: {
					text: 'You can easily create a simple course using still images',
					videoType: 'html',
					videos: ['https://taggis-assets.s3.eu-west-1.amazonaws.com/faq/TAGGIS-create-using-still-images.mp4'],
				},
				question: 'Where do I start to create my first course?',
			},
			{
				answer: {
					text: 'How can I create an interactive visual course?',
					videoType: 'youtube',
					videos: ['YurEBHW7TDg', '16yLTi8-mK0'],
				},
				question: 'Choose the 360° course option for a virtual-course look.',
			},
			{
				answer: {
					text: 'TAGGIS is the ideal tool to create a virtual environment step-by-step, with predefined actions through the use of interactive checklists.',
					videoType: 'youtube',
					videos: ['OvqFofWo63g'],
				},
				question: 'How can I create an interactive environment where users can learn about specific procedures?',
			},
			{
				answer: {
					text: 'You can stitch images using the Marzipano tool.',
					videoType: 'youtube',
					videos: ['MFho5HhrguQ'],
				},
				question: 'How can I stitch my 360 images for further use in the TAGGIS platform?',
			},
			{
				answer: { text: 'You can add:\n * Images in .png and .jpg, formats;\n * Video in .mov, .mpeg4, .avi, .wmv, .mp4;\n * Audio in .waw and record audio directly from your device.' },
				question: 'What media formats are available?',
			},
			{
				answer: { text: 'We recommend uploading video files that are less than 250 mb' },
				question: 'What file sizes are accepted by TAGGIS?',
			},
			{
				answer: { text: 'You can compose the Final Exam as an individual production. Simply click the Plus button on the dashboard and choose the Final Exam. \n * Add media files to every question\n * Use a countdown timer\n * Create new questions or use previously saved questions from the Question Pool\n * Set as many answers as you want.' },
				question: 'How can I compose a Final Exam?',
			},
			{
				answer: {
					text: 'With Question Pool you can easily store questions, assign them to multiple groups and reuse each time creating the Final Exams.',
					videoType: 'html',
					videos: ['https://taggis-assets.s3.eu-west-1.amazonaws.com/faq/TAGGIS-question-bank.mp4'],
				},
				question: 'How does the Question Pool work?',
			},
			{
				answer: {
					text: 'Add, store and assign media files to the collections. A simple way to keep all your media content at hand.',
					videoType: 'html',
					videos: ['https://taggis-assets.s3.eu-west-1.amazonaws.com/faq/TAGGIS-media-bank.mp4'],
				},
				question: 'How does the Media Bank work?',
			},
			{
				answer: {
					text: 'Create a media hotspot with one click',
					videoType: 'html',
					videos: ['https://taggis-assets.s3.eu-west-1.amazonaws.com/faq/TAGGIS-media-hotspot.mp4'],
				},
				question: 'How to create Media Hotspots?',
			},
			{
				answer: {
					text: 'The process is simple and effective:\n * Export your TAGGIS-created course via SCORM packaging and host it in the LMS system of your choice - all TAGGIS modules are SCORM compliant\n * Copy your course as a unique URL link and easily share with your end users and colleagues\n * Embed your course on your website to make it accessible to others\n * All content is hosted on our AWS Amazon servers\n * The TAGGIS platform is a cloud-based service, so production and course updates take place in real time.',
					videoType: 'html',
					videos: ['https://taggis-assets.s3.eu-west-1.amazonaws.com/faq/TAGGIS-export-copy.mp4'],
				},
				question: 'How to Export & Copy productions?',
			},
			{
				answer: { text: 'Depending on your Pricing plan the storage limit is 5 GB for Bronze, 10 GB for Silver and 15 GB for Gold package. Unlimited storage is available in the Enterprise package. Learn more about [Pricing](/pricing)' },
				question: 'Is there a limit of images I can upload to my account?',
			},
			{
				answer: { text: 'Yes, branding is available in SIlver, Gold and Enterprise packages' },
				question: 'Can I set up my own custom logo and branding?',
			},
			{
				answer: { text: 'Yes, you can distribute your courses via LMS which supports SCORM 1.2 or SCORM 2004. [Download](/samples) SCORM samples and test them in your LMS.' },
				question: 'Can I distribute my TAGGIS courses via my own LMS?',
			},
		],
	},
	freeTrial: {
		banner: {
			bannerHeading: 'Get the full experience, try TAGGIS for free',
			buttonHref: `${API.frontendAppPath}/register`,
			buttonText: 'Free Trial',
			paragraphs: ['60 days, no credit card, no obligation. ', 'No, you don’t need any prior programming skills. TAGGIS is designed to enable anyone to quickly produce highly interactive eLearning material. Why not try it and find out for yourself?'],
		},
		heading: 'Choose your pricing plan',
		paymentNotAvailable: '',
		subheading: 'Pricing',
	},
	landingPage: {
		about: {
			content: 'TAGGIS is a world unique cloud-based authoring platform, where companies can create interactive virtual environments using 360-degree panoramic images and stills. And this without any prior programming skills.',
			heading: 'We give companies the tools to create tailored, interactive eLearning courseware',
			subheading: 'What we do',
		},
		caseStudies: {
			cases: [
				{
					actionLabel: 'View 360° demo',
					brand: 'Pelesys-CAE',
					heading: 'Preflight Inspection Walkaround, Airbus A320',
					href: 'https://app.taggis.com/walkaround/6ea26199-fe2d-40fd-b0a3-ece956dcabe8/41',
					imageName: 'case-pelesys-1',
				},
				{
					actionLabel: 'View demo',
					brand: 'Norwegian Airlines',
					heading: 'First Aid Training course for Cabin Crew',
					href: 'https://app.taggis.com/procedure/24eba62e-3fc0-4363-bbeb-f96af147600f/29',
					imageName: 'case-norwegian-1',
				},
				{
					actionLabel: 'View 360° demo',
					brand: 'Norwegian Airlines',
					heading: 'Location and use of Emergency Equipment, Boeing B737',
					href: 'https://app.taggis.com/walkaround/c3178807-7f01-4d94-84c2-1be1a298a070/27',
					imageName: 'case-norwegian-2',
				},
				{
					actionLabel: 'View 360° demo',
					brand: 'Pelesys-CAE',
					heading: 'Maintenance Inspection in 3D, Airbus A320',
					href: 'https://app.taggis.com/procedure/116c527d-d196-4c4f-8d42-e8369c3740c7/42',
					imageName: 'case-pelesys-2',
				},
				{
					actionLabel: 'View 360° demo',
					brand: 'Cockpit Procedure Trainer',
					heading: 'Cockpit Normal Procedure, eLearning module',
					href: 'https://app.taggis.com/procedure/ae828d22-1618-45bc-a78a-35e9e3b5d428/15',
					imageName: 'case-cockpit',
				},
				{
					actionLabel: 'View Final Exam demo',
					brand: 'Final Exam Feature',
					heading: 'First Aid',
					href: 'https://app.taggis.com/final-exam/efb4dd0a-871c-41ee-ad99-7a2d01ee2d48/slug',
					imageName: 'case-final-exam',
				},
			],
			heading: 'See our work in action',
		},
		caseStudiesVisualExpiriences: {
			cases: [
				{
					actionLabel: 'View demo',
					brand: 'Real Estate Agency',
					heading: 'Real Estate Presentation',
					href: 'https://app.taggis.com/walkaround/e6fc33ea-2315-4192-b1dd-e757a3b3eaca/1388',
					imageName: 'case-realestate',
				},
				{
					actionLabel: 'View demo',
					brand: 'Luxury Yacht Manufacturer',
					heading: 'Interactive sales presentation of luxury boats',
					href: 'https://app.taggis.com/walkaround/29d21488-dc09-41df-89ec-17fcfc344b70/1121',
					imageName: 'case-yachts',
				},
				{
					actionLabel: 'View demo',
					brand: 'Conference and Meeting Facilities',
					heading: 'Interactive presentation of conference and meeting rooms',
					href: 'https://app.taggis.com/walkaround/2d57c4f6-0d19-44e9-9d1d-4b850ca8d8f4/1132',
					imageName: 'case-meeting-rooms',
				},
			],
			heading: 'We are expanding - many businesses rely on visual experiences',
		},
		contactUs: {
			address: 'Virtual eTraining AB\nHornsgatan 24\n118 20 Stockholm\nSweden',
			buttonLabel: 'Accept & send',
			mapHeading: 'Find us',
			mapQuery: 'Virtual eTraining Software AB Stockholm',
			successDialog: {
				content: 'We will be in touch shortly.',
				heading: 'Thank you!',
				linkLabel: 'Get back',
			},
			termsContent: 'By submitting this form, you hereby agree that Virtual eTraining Software may collect, obtain, store and process your personal data to handle your request. We respect your [privacy](/privacy).',
		},
		downloadBrochure: {
			buttonLabel: 'Download full company brochure',
			fileName: 'TAGGIS-Promo-2022.pdf',
			heading: 'Want to learn more?',
		},
		footer: {
			address: 'Virtual eTraining AB\nHornsgatan, 24\n118 20 Stockholm\nSweden\n[info@taggis.com](mailto:info@taggis.com)',
			content: 'Copyright © {year} Virtual eTraining AB. All rights reserved.',
		},
		getInTouch: {
			content: 'We’re ready to lead you into the future. Create virtual environments with us.',
			heading: 'Get in touch with us',
			subheading: 'Contact',
		},
		hero: {
			buttonLabel: 'Try free trial',
			emailAddress: 'info@taggis.com',
			heading: 'Create immersive eLearning experiences',
			href: `${API.frontendAppPath}/register`,
			phoneNumber: '',
			startsCount: 20,
			subheading: 'It’s easy',
		},
		howItWorks: {
			content: 'Let us show you how easy it is to create your own 360° virtual environments without having to hire expensive photographers.',
			heading: 'Create your own virtual environment using our Weiss Civetta 360° camera.',
		},
		learnTestExport: {
			content: 'Users can explore and test their knowledge. The platform is compatible with any LMS, so exporting results is super easy.',
			heading: 'Learn.\nTest.\nExport.',
			imageToRight: true,
		},
		navigation: {
			items: [
				{ href: '#projects', name: 'Our projects' },
				// { href: '#free-trail', name: 'Free trial' },
				{ href: '/pricing', name: 'Pricing' },
				{ href: '/news', name: 'News' },
				{ href: '#clients', name: 'Our clients' },
				// { href: '#camera', name: 'Camera' },
				{ href: '#about', name: 'About & Contact' },
				{ href: '/samples', name: 'SCORM Samples' },
				{ href: '/faq', name: 'FAQ' },
				{ href: `${API.frontendAppPath}/sign-in`, name: 'Sign in' },
			],
		},
		new: {
			buttonLabel: 'Stay tuned',
			content: ['Training courses created through TAGGIS can now be exported to our content distribution platform, DocBrowser, and sent to users immediately.  We even go a step further, where from now on all SCORM-compatible e-learning material will work on DocBrowser. You won’t need a separate LMS, because with DocBrowser you can: host courses, distribute them, and track usage.', 'The integration of our services provides significant cost savings, and every action ensures full security.', 'With just a few clicks, and our DocBrowser iOS App, you’re good to go.'],
			heading: 'The integrated LMS is on the way',
			href: '#about',
		},
		ourClients: {
			clients: [
				{
					imageName: 'norwegian.svg',
				},
				{
					imageName: 'h.svg',
				},
				{
					imageName: 'ryanair.svg',
				},
				{
					imageName: 'wax.svg',
				},
				{
					imageName: 'pelesys.png',
				},
				{
					imageName: 'air-berlin.svg',
				},
				{
					imageName: 'cae.svg',
				},
				{
					imageName: 'tui.svg',
				},
				{
					imageName: 'skistar.svg',
				},
				{
					imageName: 'raddison.svg',
				},
				{
					imageName: 'novair.svg',
				},
				{
					imageName: 'air-canada.svg',
				},
				{
					imageName: 'sas.svg',
				},
			],
			heading: 'Our clients',
		},
		priceCards: {
			heading: 'Pricing',
			priceOptions: [
				{
					buttonLabel: 'Get started',
					features: [
						'Upload of 360° & still images',
						'Hotspot Editor',
						'Training Quiz',
						'Cloud Based Storage',
						'Export via URL-link',
					],
					heading: 'Free trial',
					href: `${API.frontendAppPath}/register`,
					price: '$ 0',
					term: '60 days',
				},
				{
					buttonLabel: 'Get started',
					features: [
						'Upload of 360° & still images',
						'Hotspot Editor',
						'Training Quiz & Final Exams',
						'Cloud Based Storage',
						'Export via URL-link & SCORM packaging',
					],
					heading: 'Custom',
					href: `${API.frontendAppPath}/register`,
					price: 'Get a quote',
					term: '',
				},
			],
		},
		quotes: {
			heading: 'Testimonials',
			quotes: [
				{
					author: 'Jim Cairns, VP Maintenance Training, CAE-Pelesys',
					quote: 'Adding the TAGGIS product to our courseware provides a sense of realism that can virtually replace the need of going out to the aircraft.',
				},
				{
					author: 'Siri Aronsen, Senior Ground Instructor, Training Departement Norwegian Air Shuttle',
					quote: 'The TAGGIS editing interface is simple and user friendly. We can add text and images to the 360° environment, together with tests and other updates, which saves us both time and money.',
				},
				{
					author: 'Allan Greene, VP Business Development, CAE-Pelesys',
					quote: 'We see great potential in the TAGGIS platform and the possibilities for us and our customers to create and distribute their own interactive training.',
				},
				{
					author: 'Henrik Krantz - Chief Ground Instructor TUIfly Nordic',
					quote: 'The TAGGIS editor is so user-friendly and we have had great use of the tool, and will continue to use it in the future!',
				},
			],
		},
		seeHow: {
			heading1: 'See how',
			heading2: 'it works',
			videoId: 'RhPJM_wlByc',
		},
		taggisAndDocBrowser: {
			buttonLabel: 'Learn more',
			content:
								'The versatility of SaaS has galvanized our work to deliver a complete digital-systems experience; through [{R}TAGGIS](/sign-in), where companies can create their own interactive imagery environments, and through [DocBrowser](https://docbrowser.io), where aviation industry updates are automatically delivered to airlines. Soon these two sister companies will integrate so that visual elements can be added to digital documents for ultimate relatability.',
			heading: 'TAGGIS & DocBrowser for a full digital package',
			href: `${API.frontendAppPath}/sign-in`,
		},
		trialOffer: {
			buttonLabel: 'Free trial',
			content:
								'30 days, no credit card, no obligation.\n\nNo, you don’t need any prior programming skills. TAGGIS is designed to enable anyone to quickly produce highly interactive eLearning material. Why not try it and find out for yourself?',
			heading: 'Get the full experience, try TAGGIS for free',
			href: '/register',
			subheading: 'Free trial 30 days',
		},
		uploadVisuals: {
			content:
								'Through TAGGIS you can produce your own interactive eLearning experience in just three simple steps.',
			heading: 'Upload visuals.\nAdd interactivity.\nShare.',
			imageToRight: false,
		},
		watchTaggis: {
			heading: 'Learn more about us in pictures',
			heading1: 'Watch TAGGIS',
			heading2: 'in action',
			videoId: 'u9hmvpYM88I',
		},
		whoWeAre: {
			content: 'Since 2007 Virtual eTraining Software has brought SaaS to another level. We have helped to shape, and we continue to transform, the digital landscape of aviation training. We have made virtual reality (VR) accessible to all; companies can produce interactive environments themselves, and together with invaluable input from aviation professionals an excellent user experience is guaranteed.\n\nThe versatility of virtual-reality software has expanded our business into new fields, including construction, real estate and the list goes on.',
			heading: 'Virtual eTraining — the company behind TAGGIS',
			subheading: 'Who we are',
		},
	},
	newsPage: {
		heading: {
			subTitle: 'News',
			title: 'What is new?',
		},
		news: [
			{
				categories: [{ name: 'TAGGIS', value: 'category1' }, { name: 'ELearning', value: 'category2' }],
				content: 'Article about the launch of TAGGIS in eLearning Industry. eLearning Industry is a leading publishing platform that delivers inspiring, industry-specific content to eLearning professionals.\n\n [Link to article](https://elearningindustry.com/press-releases/virtual-etraining-software-launched-taggis)',
				createdData: '19.11.2021',
				id: 1,
				media: {
					image: {
						alt: 'TAGGIS in eLearning Industry',
						src: 'article1-image.png',
					},
				},
				title: 'TAGGIS in eLearning Industry',
			},
			{
				categories: [{ name: 'TAGGIS', value: 'category1' }, { name: 'ELearning', value: 'category2' }],
				content: 'The creator of TAGGIS has in this article, “The Power of Pictures: How Far Does it Go?”,  described the power and strength of using images and visual media in eLearning course materials.\n\n [Link to article](https://trainingindustry.com/blog/content-development/the-power-of-pictures-how-far-does-it-go/)',
				createdData: '19.11.2021',
				id: 2,
				media: {
					image: {
						alt: 'The Power of Pictures',
						src: 'article2-image.png',
					},
				},
				title: 'The Power of Pictures',

			},
			{
				categories: [{ name: 'TAGGIS', value: 'category1' }],
				content: 'Article in CAT Magazine, the Journal for Civil Aviation Training, which explores the use of new technologies (such as TAGGIS) for cabin crew training and how it is currently used in training departments.\n\n [Link to article](https://issuu.com/halldale/docs/cat_2_2014/32)',
				createdData: '19.11.2021',
				id: 3,
				media: {
					image: {
						alt: 'TAGGIS in CAT Magazine',
						src: 'article3-image.png',
					},
				},
				title: 'TAGGIS in CAT Magazine',
			},
			{
				categories: [{ name: 'TAGGIS', value: 'category1' }, { name: 'Collaboration', value: 'category3' }],
				content: 'TAGGIS now in collaboration with [gds GmbH](https://gds.eu) in the development of [WingDox](https://wingdox.com), a new documentation and training system for the aviation industry.\n\n [Link to press release](https://www.gds.eu/nl/nieuws-blog/persbericht-gds-gmbh-and-it-flight-ops-solutions-ab-develop-wingdox)',
				createdData: '19.11.2021',
				id: 4,
				media: {
					image: {
						alt: 'TAGGIS in new collaboration',
						src: 'article4-image.png',
					},
				},
				title: 'TAGGIS in new collaboration',
			},
		],
	},
	notifications: {
		cookiePolicy: {
			buttonLabel: 'Accept cookies',
			content: '**We use [cookies](/cookies) to personalise content and ads, and to analyse our traffic.** We also share information about your use of our site with our social media, advertising, and analytic platforms who may combine it with other information that you’ve provided to them.',
		},
		pwaUpdate: {
			buttonLabel: 'Refresh now',
			content: '**There are new updates available.** We’ve made some changes to this page. Refresh and see the latest version.',
		},
	},
	pricing: {
		heading: 'Pricing',
		plans: [
			{ extraInfo: '',
				features: [
					{ checked: 1, name: 'SCORM Export' },
					{ checked: 1, name: '5 Productions' },
					{ checked: 1, name: '4 Final-Exams' },
					{ checked: 1, name: '5 GB Storage' },
					{ checked: 1, name: 'Views per year: 50 000' },
					{ checked: 1, name: 'Copy Course' },
					{ checked: 1, name: '360 Gallery: 5' },
					{ checked: 0, name: 'Branding' },
					{ checked: 0, name: 'Flow Pattern' },
				],
				id: 1,
				price: 99,
				title: 'Bronze',
			},
			{ extraInfo: '',
				features: [
					{ checked: 1, name: 'SCORM Export' },
					{ checked: 1, name: '10 Productions' },
					{ checked: 1, name: '8 Final-Exams' },
					{ checked: 1, name: '10 GB Storage' },
					{ checked: 1, name: 'Views per year: 100 000' },
					{ checked: 1, name: 'Copy Course' },
					{ checked: 1, name: '360 Gallery: 10' },
					{ checked: 1, name: 'Branding' },
					{ checked: 0, name: 'Flow Pattern' },
				],
				id: 2,
				price: 149,
				title: 'Silver',
			},
			{	extraInfo: '',
				features: [
					{ checked: 1, name: 'SCORM Export' },
					{ checked: 1, name: '20 Productions' },
					{ checked: 1, name: '16 Final-Exams' },
					{ checked: 1, name: '15 GB Storage' },
					{ checked: 1, name: 'Views per year: 150 000' },
					{ checked: 1, name: 'Copy Course' },
					{ checked: 1, name: '360 Gallery: 10' },
					{ checked: 1, name: 'Branding' },
					{ checked: 1, name: 'Flow Pattern' },
				],
				id: 3,
				price: 219,
				title: 'Gold',
			},
			{ extraInfo: '',
				features: [
					{ checked: 1, name: 'SCORM Export' },
					{ checked: 1, name: 'Unlimited Productions' },
					{ checked: 1, name: 'Unlimited Final-Exams' },
					{ checked: 1, name: 'Unlimited Storage' },
					{ checked: 1, name: 'Views per year: Unlimited' },
					{ checked: 1, name: 'Copy Course' },
					{ checked: 1, name: '360 Gallery: Unlimited' },
					{ checked: 1, name: 'Branding' },
					{ checked: 1, name: 'Flow Pattern' },
				],
				id: 4,
				price: 'Custom Pricing',
				title: 'Enterprise',
			},
		],
	},

	samples: {
		heading: 'Test SCORM samples',
		scormSamples: [
			{
				downloadLink: 'https://taggis-assets.s3.eu-west-1.amazonaws.com/Emergency+and+Loose+Equipment.zip',
				id: 1,
				iframeLink: 'https://app.taggis.com/walkaround/c3178807-7f01-4d94-84c2-1be1a298a070/27',
				title: '360° Course',
			},
			{
				downloadLink: 'https://taggis-assets.s3.eu-west-1.amazonaws.com/First+Aid.zip',
				id: 2,
				iframeLink: 'https://app.taggis.com/final-exam/efb4dd0a-871c-41ee-ad99-7a2d01ee2d48/slug',
				title: 'Final-exam',
			},
			{
				downloadLink: 'https://taggis-assets.s3.eu-west-1.amazonaws.com/First+Aid+Medical+Incidents.zip',
				id: 3,
				iframeLink: 'https://app.taggis.com/procedure/24eba62e-3fc0-4363-bbeb-f96af147600f/29',
				title: 'Procedure',
			},
		],
		subHeading: 'Samples',
	},
};



// WEBPACK FOOTER //
// ./src/constants/content/languages/en.js